import React from "react";

function HowWork() {
  return (
    <div>
      {" "}
      <div
        style={{
          padding: "2rem 0px",
          background: "#f8fbff",
        }}
      >
        <div className="container">
          <div className="row">
            <h5 className="levbitz_subtitle">How We work </h5>
            <div className="bottom_design"></div>

            <div>
              <h5
                style={{
                  lineHeight: "40px",
                }}
                className=""
              >
                Cauvery cars is the most trusted way of buying used cars. Choose
                from over 4000 fully inspected second-hand car models. Select
                online and book a test drive at your home or at a Cauvery Car
                Hub. Get a guarantee and a free one-year comprehensive service
                warranty with Assured Resale Value on every Cauvery car
                Assured car
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowWork;
